import React, { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';

const FarmerRegistration = lazy(() => import('../../container/admin/farmer/farmerRegistration'));
const FarmerList = lazy(() => import('../../container/admin/farmer/farmerList'));
const FarmerUpdate = lazy(() => import('../../container/admin/farmer/farmerUpdate'));
const FarmerDetail = lazy(() => import('../../container/admin/farmer/FarmerDetail/farmerDetails'));

function FarmerRoute() {
  return (
    <Routes>
      <Route path="registration" element={<FarmerRegistration />} />
      <Route path="list" element={<FarmerList />} />
      <Route path="update/:id" element={<FarmerUpdate />} />
      {/* <Route path="detail/:id" element={<FarmerUpdate />} /> */}
      <Route path="detail/:id" element={<FarmerDetail />} />
    </Routes>
  );
}

export default FarmerRoute;
